module.exports = __webpack_public_path__ + "img/ico-chest-1.394146e3.png";